"use client";

import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import styles from "./BlogHero.module.css";

export default function BlogHero() {
  const T = useT();

  return (
    <div className={styles.container}>
      <div className={styles.headline}>
        <div className={`${styles.badgeContainer} ${styles.animateSlideUp}`}>
          <div className={styles.badge}>
            <span className={styles.dot}></span>
            <span>{T(TKey.BLOG_HERO_BADGE)}</span>
          </div>
        </div>

        <h1 className={styles.title}>
          <span className={`${styles.titleLine} ${styles.animateSlideUp} ${styles.delay1}`}>
            {T(TKey.BLOG_HERO_TITLE_1)}
          </span>
          <span
            className={`${styles.titleLine} ${styles.titleEmphasized} ${styles.animateSlideUp} ${styles.delay2}`}
          >
            <span className={`${styles.highlight} ${styles.titleHighlight}`}>
              {T(TKey.BLOG_HERO_TITLE_2)}
            </span>
          </span>
        </h1>

        <p className={`${styles.text} ${styles.animateSlideUp} ${styles.delay3}`}>
          {T(TKey.BLOG_HERO_TEXT)}
        </p>
      </div>
    </div>
  );
}
